<template>
  <div class="review-list" ref="ReviewRef">
    <div class="title-box">稽核事件列表</div>
    <!-- 查询条件 -->
    <el-form
      id="formID"
      :inline="true"
      :model="queryParams"
      style="border-radius: 3px; margin-bottom: 10px; box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1)"
      class="demo-form-inline"
    >
      <el-row>
        <el-form-item>
          <el-select
            ref="factorySelect"
            v-model="queryParams.factoryId"
            filterable
            placeholder="选择工厂"
            clearable
            @change="getWorkshopByFactory"
          >
            <el-option v-for="item in factoryOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            ref="workshopSelect"
            v-model="queryParams.workshopId"
            filterable
            clearable
            placeholder="选择车间"
            @change="getSceneByWorkshop"
          >
            <el-option v-for="item in workshopOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select ref="sceneSelect" placeholder="选择场景" v-model="queryParams.sceneId" clearable filterable>
            <el-option v-for="item in sceneOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="queryParams.eventStartTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="queryParams.eventEndTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="onReset">重置</el-button>
        </el-form-item>
        <!-- 表格/图表切换 -->
        <el-form-item style="float: right">
          <!-- 删除添加按钮 -->
          <!-- <span>
            <i
              @click="addVideoAiEvent"
              style="
                background: #c7c7c7;
                cursor: pointer;
                color: #fff;
                width: 32px;
                height: 32px;
                text-align: center;
                margin-top: 18px;
                padding-top: 7px;
                border-radius: 3px;
              "
              class="el-icon-plus"
            ></i>
          </span>
          <span v-hasPermi="['enterpr:diffpressure:export']" @click="exportData()" class="tool-icon">
            <img src="@/assets/images/download.png" />
          </span> -->
        </el-form-item>
      </el-row>
    </el-form>
    <div>
      <!-- 表格 -->
      <el-table
        :data="tableData"
        border
        :style="{ height: tableHeight + 'px', width: '100%', 'border-radius': '3px' }"
        class="custom-table-header"
        :height="tableHeight"
      >
        <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
        <el-table-column prop="factoryName" label="工厂" align="center"></el-table-column>
        <el-table-column prop="workshopName" label="车间" align="center"></el-table-column>
        <el-table-column prop="sceneName" label="场景" align="center"></el-table-column>

        <el-table-column prop="eventType" label="事件类型" width="100" align="center"></el-table-column>
        <el-table-column prop="eventStartTime" label="事件开始时间" align="center"></el-table-column>
        <!-- <el-table-column prop="" label="事件持续时长" align="center"></el-table-column> -->
        <el-table-column prop="eventEndTime" label="事件结束时间" align="center"></el-table-column>
        <el-table-column label="稽核截图" align="center" prop="url">
          <template #default="scope">
            <!--         v-if="previewListResource && checkFileSuffix(scope.row.fileSuffix)" -->
            <!-- <ImagePreview :width="100" :height="100" :src="scope.row.url" :preview-src-list="[scope.row.url]" />
            <span v-if="!checkFileSuffix(scope.row.fileSuffix) || !previewListResource" v-text="scope.row.url" /> -->
          </template>
        </el-table-column>
        <el-table-column prop="reviewResult" label="事件描述" align="center"></el-table-column>
        <el-table-column prop="reviewPersonName" label="稽核人" align="center"></el-table-column>
        <el-table-column prop="reviewTime" label="稽核时间" align="center"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="block" style="background: #fff; text-align: center; padding: 20px 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNation.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageNation.pageSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { getDateOneWeekAgo, formatDate } from '@/utils/base';
import * as echarts from 'echarts';
import { download } from '@/utils/request';
import request from '@/utils/request';
import api from '@/utils/api';
import { Message, MessageBox } from 'element-ui';
import ImagePreview from '@/components/ImagePreview/index.vue';
export default {
  data() {
    return {
      // 查询条件
      queryParams: {
        factoryId: '',
        workshopId: '',
        sceneId: '',
        eventStartTime: '',
        eventEndTime: ''
      },
      //工厂数据
      factoryOptions: [],
      // 车间数据
      workshopOptions: [],
      sceneOptions: [],
      deviceNumList: [],
      total: 0,
      tableHeight: 650,
      // 表格数据
      tableData: [],
      lineChart: null,
      sourceTime: [],
      pdiData: [],
      pageNation: {
        pageNum: 1,
        pageSize: 20
      },
      previewListResource: false
    };
  },
  components: {
    ImagePreview
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    this.getList();
    this.getFactoryByCustomer();
  },
  methods: {
    // 删除
    handleDelete(row) {
      const aiEventId = row?.id;
      const aiEventName = '';
      MessageBox.confirm('是否确认删除' + aiEventName + '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          request
            .delete(`${api.videoCheck.delCheckVideo}/${aiEventId}`)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('删除成功');
                this.getList();
              } else {
                this.$message.error('删除失败');
              }
            })
            .catch((err) => {
              this.$message.error('删除失败');
            });
        })
        .catch(() => {});
    },
    gotoVideoAi(row) {
      this.$router.push({
        path: '/monitor-data/reviewDetail',
        query: {
          id: row.id
        }
      });
    },
    // 添加视频Ai事件
    addVideoAiEvent() {},
    // 监听窗口缩放
    handleResize() {
      // 当窗口大小变化时，这个函数会被调用
      const height = window.innerHeight;
      // 你可以在这里添加你的处理代码
      let dom = document.getElementById('formID');
      let formH = 70; //一行时高度为70
      if (dom) {
        formH = dom.offsetHeight;
      }
      this.tableHeight = height - 190 - formH; //表单的高度会变化
      // 设置表格体高度
      let tableBody = document.getElementsByClassName('el-table__body-wrapper')[0];
      if (tableBody) {
        tableBody.style.height = this.tableHeight - 40 + 'px';
      }
    },
    // 查询
    onSubmit() {
      this.getList();
    },
    // 重置
    onReset() {
      let eDate = formatDate(new Date());
      let sDate = getDateOneWeekAgo(3);
      this.queryParams = {
        factoryId: '',
        workshopId: '',
        sceneId: '',
        eventStartTime: '',
        eventEndTime: ''
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.queryParams.pageNum = 1;
      this.pageNation.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    // 根据客户查询工厂
    getFactoryByCustomer() {
      this.$store.dispatch('workshop/getFactoryByCustomer').then((result) => {
        this.factoryOptions = result?.data;
      });
    },
    // 根据工厂查询车间
    getWorkshopByFactory() {
      this.$store.dispatch('scene/getWorkshopByFactory', { factoryId: this.queryParams.factoryId }).then((result) => {
        this.queryParams.workshopId = null;
        if (result && result.data && result.data.length > 0) {
          this.workshopOptions = result.data;
        } else {
          this.workshopOptions = [];
        }
      });
    },
    // 根据车间查询场景
    getSceneByWorkshop() {
      this.$store
        .dispatch('monitorData/getSceneByWorkshop', { workshopId: this.queryParams.workshopId })
        .then((result) => {
          this.queryParams.sceneId = null;
          if (result && result.data && result.data.length > 0) {
            this.sceneOptions = result.data;
          } else {
            this.sceneOptions = [];
          }
        });
    },
    checkFileSuffix(fileSuffix) {
      const arr = ['.png', '.jpg', '.jpeg'];
      const suffixArray = Array.isArray(fileSuffix) ? fileSuffix : [fileSuffix];
      return suffixArray.some((suffix) => arr.includes(suffix.toLowerCase()));
    },
    getList() {
      const params = {
        ...this.queryParams,
        ...this.pageNation
      };
      this.previewListResource = true;
      request
        .get(`${api.videoCheck.getCheckList}`, {
          params: params
        })
        .then((res) => {
          if (res.code === 200 && res?.rows) {
            this.tableData = res.rows || [];
            this.total = res.total || 0;
            this.previewListResource = true;
          } else {
            this.tableData = [];
            this.total = 0;
            this.previewListResource = false;
          }
        })
        .catch((err) => {
          this.tableData = [];
          this.total = 0;
          this.previewListResource = false;
        });
    },
    // 导出
    exportData() {
      const params = { ...this.queryParams, ...this.pageNation };
      download(
        '/biz/eventCameraAudit/export',
        {
          ...params
        },
        `eventCamera_${new Date().getTime()}.xlsx`
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-video {
  color: #3083fb;
  cursor: pointer;
}
.title-box {
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  padding: 27px 0 15px;
  line-height: 16px;
}
// 表头背景色
::v-deep .custom-table-header th {
  background-color: #ebeef5 !important;
}
// 表格字体大小
.el-table {
  font-size: 12px;
}
// 表单底部边界线
.el-table::before {
  height: 0px;
}
// 表格字体
::v-deep .el-table thead {
  color: #606266;
}
// 表格内边距
::v-deep .el-table .el-table__cell {
  padding: 8px 0;
}
// 表单底部margin
.el-form-item {
  margin-bottom: 0;
}
// 当前页码样式
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #ff9f07;
}
// 页面hover样式
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #ff9f07;
}
// .el-button{
//     font-size: 12px;
// }
::v-deep .el-form-item__label {
  font-size: 12px;
}
::v-deep .el-table__body-wrapper {
  height: 100%;
  overflow-y: auto;
}
.tool-icon {
  width: 28px;
  height: 32px;
  cursor: pointer;
  background: #c7c7c7;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  border-radius: 4px;
  margin-left: 5px;
}
.select-icon {
  background: #3083fb;
}
</style>
